import NotificationSnackbarSlice from "../components/base/NotificationSnackbar/NotificationSnackbarSlice";
import * as AppConstants from "./AppConstants"

export const isUser = (me) => {
  if (!me) {
    return false;
  } else {
    let listOfRoleLabel = [];
    for (let i = 0; i < me?.roles?.length; i++) {
      listOfRoleLabel.push(me?.roles[i]?.roleLabel);
    }
    if (listOfRoleLabel.indexOf(AppConstants.ROLE_LABEL.USER) >= 0) {
      return true;
    } else {
      return false;
    }
  }
}

export const isStudent = (me) => {
  if (!me) {
    return false;
  } else {
    return me?.user?.userType == AppConstants.USER_TYPE.STUDENT.NAME;
  }
}

export const isStaff = (me) => {
  if (!me) {
    return false;
  } else {
    return me?.user?.userType == AppConstants.USER_TYPE.STAFF.NAME;
  }
}

export const deleteAllCookies = () => {
  const cookies = document.cookie.split(";");
  for (const cookie of cookies) {
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
}

export const displaySuccessSnackbar = (result) => {
  return NotificationSnackbarSlice.actions.appendNotification({ severity: "success", message: result.message });
}

export const displayErrorSnackbar = (error) => {
  return NotificationSnackbarSlice.actions.appendNotification({ severity: "warning", message: error.message });
}

export const downloadFile = (fileName, contentBlob) => {
  const downloadLink = document.createElement("a");
  downloadLink.download = fileName;
  downloadLink.innerHTML = "Download File";
  if (window.webkitURL != null) {
    // Chrome allows the link to be clicked
    // without actually adding it to the DOM.
    downloadLink.href = window.webkitURL.createObjectURL(contentBlob);
  }
  else {
    // Firefox requires the link to be added to the DOM
    // before it can be clicked.
    downloadLink.href = window.URL.createObjectURL(contentBlob);
    downloadLink.onclick = (event)=>{document.body.removeChild(event.target);};
    downloadLink.style.display = "none";
    document.body.appendChild(downloadLink);
  }
  downloadLink.click();
  if (window.webkitURL != null) {
    downloadLink.href = window.webkitURL.revokeObjectURL(contentBlob);
  }
  else {
    downloadLink.href = window.URL.revokeObjectURL(contentBlob);
  }
}